// Logs a message and an object, returning the object.
// Useful for logging values in simple arrow functions, like `value => doAnotherThing(trace(doSomething(value)))`
export function trace(message: string, object: any) {
  return traceo(message, object, object);
}

export function traceo(message: string, objectToBeTraced: any, objectToBeReturned: any) {
  console.log(message, objectToBeTraced);
  return objectToBeReturned;
}

export function breakpoint<T>(value: T): T {
  debugger;
  return value;
}
